import { useState } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "./components/Sidebar";
import Topbar from "./components/Topbar";
import { useRequireAuth } from "./guard";

export default function AdminLayout() {
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const { user, loading, signOut } = useRequireAuth();

  if (loading) {
    return (
      <div className="min-h-screen w-full flex items-center justify-center bg-background-50">
        <div className="flex flex-col items-center gap-3">
          <span className="flex items-center justify-center w-12 h-12 rounded-2xl bg-primary-600 text-background-50">
            <i className="ri-loader-4-line animate-spin text-xl"></i>
          </span>
          <p className="text-sm text-foreground-600">Loading admin...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen w-full bg-background-50">
      <Sidebar
        collapsed={collapsed}
        onToggle={() => setCollapsed((v) => !v)}
        onNavigate={() => setMobileOpen(false)}
      />

      {/* Mobile overlay */}
      {mobileOpen && (
        <div
          className="fixed inset-0 z-30 bg-black/30 lg:hidden"
          onClick={() => setMobileOpen(false)}
        ></div>
      )}

      <div className={`transition-all duration-300 ${collapsed ? "lg:pl-[72px]" : "lg:pl-[248px]"}`}>
        <Topbar
          user={user}
          onMenuClick={() => setMobileOpen((v) => !v)}
          onSignOut={signOut}
        />
        <main className="p-4 md:p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
}